import script from "./FeedbackDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeedbackDialog.vue?vue&type=script&lang=ts&setup=true"

import "./FeedbackDialog.vue?vue&type=style&index=0&id=ae989ed6&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae989ed6"]])

export default __exports__